export default __webpack_public_path__ + "static/media/TikTok_JSON.6019df56.PNG";